// Tooltip Functionality
document.addEventListener('DOMContentLoaded', function() {
    const tooltipElements = document.querySelectorAll('.tooltip');
    
    if (tooltipElements.length === 0) return;
    
    // Create tooltip element
    function createTooltip() {
        const tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.style.cssText = `
            position: absolute;
            background: #333;
            color: white;
            padding: 8px 12px;
            border-radius: 6px;
            font-size: 14px;
            line-height: 1.4;
            z-index: 1000;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s ease, visibility 0.3s ease;
            pointer-events: none;
            max-width: 250px;
            word-wrap: break-word;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        `;
        
        // Add arrow
        const arrow = document.createElement('div');
        arrow.className = 'tooltip-arrow';
        arrow.style.cssText = `
            position: absolute;
            width: 0;
            height: 0;
            border: 6px solid transparent;
        `;
        
        // Ensure arrow is properly appended
        if (tooltip && arrow) {
            tooltip.appendChild(arrow);
        }
        
        document.body.appendChild(tooltip);
        return tooltip;
    }
    
    const tooltip = createTooltip();
    let currentElement = null;
    
    // Position tooltip
    function positionTooltip(element, tooltip) {
        const rect = element.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        
        // Default position (above element)
        let top = rect.top - tooltipRect.height - 12;
        let left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
        let arrowPosition = 'bottom';
        
        // Adjust if tooltip goes off screen
        if (top < 10) {
            // Show below element
            top = rect.bottom + 12;
            arrowPosition = 'top';
        }
        
        if (left < 10) {
            left = 10;
        } else if (left + tooltipRect.width > viewportWidth - 10) {
            left = viewportWidth - tooltipRect.width - 10;
        }
        
        // Position tooltip
        tooltip.style.top = `${top + window.scrollY}px`;
        tooltip.style.left = `${left}px`;
        
        // Position arrow
        const arrow = tooltip.querySelector('.tooltip-arrow');
        
        // Only proceed if arrow element exists
        if (arrow) {
            const arrowOffset = Math.min(Math.max(0, rect.left + (rect.width / 2) - left - 6), tooltipRect.width - 12);
            
            if (arrowPosition === 'bottom') {
                arrow.style.top = '100%';
                arrow.style.left = `${arrowOffset}px`;
                arrow.style.borderTopColor = '#333';
                arrow.style.borderBottomColor = 'transparent';
            } else {
                arrow.style.bottom = '100%';
                arrow.style.left = `${arrowOffset}px`;
                arrow.style.borderBottomColor = '#333';
                arrow.style.borderTopColor = 'transparent';
            }
        }
    }
    
    // Show tooltip
    function showTooltip(element) {
        const tooltipInfo = element.getAttribute('data-tooltip-info');
        if (!tooltipInfo) return;
        
        currentElement = element;
        tooltip.textContent = tooltipInfo;
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '1';
        
        // Position tooltip
        positionTooltip(element, tooltip);
    }
    
    // Hide tooltip
    function hideTooltip() {
        if (currentElement) {
            tooltip.style.opacity = '0';
            tooltip.style.visibility = 'hidden';
            currentElement = null;
        }
    }
    
    // Add event listeners to all tooltip elements
    tooltipElements.forEach(element => {
        // Mouse enter
        element.addEventListener('mouseenter', function(e) {
            showTooltip(this);
        });
        
        // Mouse leave
        element.addEventListener('mouseleave', function(e) {
            hideTooltip();
        });
        
        // Focus (for keyboard accessibility)
        element.addEventListener('focus', function(e) {
            showTooltip(this);
        });
        
        // Blur (for keyboard accessibility)
        element.addEventListener('blur', function(e) {
            hideTooltip();
        });
    });
    
    // Hide tooltip on scroll or resize
    window.addEventListener('scroll', hideTooltip, { passive: true });
    window.addEventListener('resize', hideTooltip, { passive: true });
    
    // Hide tooltip when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.tooltip')) {
            hideTooltip();
        }
    });
});
